import { render, staticRenderFns } from "./kapanistanacilis.vue?vue&type=template&id=a17f7a5a&"
import script from "./kapanistanacilis.vue?vue&type=script&lang=js&"
export * from "./kapanistanacilis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports